var map = {
	"./as.json": [
		2229,
		229
	],
	"./bn.json": [
		9082,
		924
	],
	"./brx.json": [
		3781,
		781
	],
	"./doi.json": [
		6318,
		318
	],
	"./en.json": [
		1700
	],
	"./gu.json": [
		2660,
		660
	],
	"./hi.json": [
		866,
		866
	],
	"./kn.json": [
		1943,
		943
	],
	"./kok.json": [
		2809,
		809
	],
	"./ks.json": [
		8082,
		82
	],
	"./ma.json": [
		6917,
		917
	],
	"./mai.json": [
		5533,
		533
	],
	"./ml.json": [
		3477,
		477
	],
	"./mni.json": [
		4876,
		876
	],
	"./ne.json": [
		3130,
		130
	],
	"./or.json": [
		4954,
		954
	],
	"./pa.json": [
		5154,
		154
	],
	"./sa.json": [
		9713,
		713
	],
	"./sd.json": [
		1202,
		202
	],
	"./ta.json": [
		4028,
		28
	],
	"./te.json": [
		244,
		244
	],
	"./ur.json": [
		6429,
		429
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7875;
module.exports = webpackAsyncContext;